// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 导入css，此css存放的是全局项目需要的css
import '@/assets/css/default.css'
import qs from 'qs'
import moment from 'moment' //导入文件
import "@/assets/js/directive.js";
import '@/assets/js/loginInfo.js'
import airspaceObj from "@/assets/js/map/airspace.js";

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$qs = qs;
Vue.prototype.$moment = moment; //赋值使用

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});
//获取页面按钮权限
Vue.prototype.getPageBtnRole = function(key) {
  let btnPermissionList = JSON.parse(sessionStorage.getItem("uPermissionList"))
  function findChildrenByKey(tree, key) {
    for (let node of tree) {
      if (node.path === key && node.children) {
        return node.children.map(o=>(o.path))
      }
      if (node.children && node.children.length > 0) {
        const result = findChildrenByKey(node.children, key);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }
  return  findChildrenByKey(btnPermissionList,key)
};
//检查对象是否为空
Vue.prototype.isEmptyObj = function(obj) {
    if (null === obj || undefined === obj) {
        return true;
    }
    return false;
};

//检查字符串是否为空
Vue.prototype.isEmptyStr = function(str) {
    if (null == str || (str + "").trim().length <= 0) {
        return true;
    }
    return false;
};
//检查数组是否为空
Vue.prototype.isEmptyArray = function(arr) {
    if (null == arr || arr.length <= 0) {
        return true;
    }
    return false;
};
//点击按钮设置值
Vue.prototype.addOrReducePoint = function(type, add) {
    let data = 0;
    if (
        this.$data.commonForm[type] &&
        parseFloat(this.$data.commonForm[type])
    ) {
        data = parseFloat(this.$data.commonForm[type]);
    }
    if (add) {
        data += 1;
    } else {
        data -= 1;
    }
    const rules = this.$data.pointRange[type];
    if (null != rules && rules.min <= data && data <= rules.max) {} else if (
        (!this.$data.commonForm[type] || isNaN(this.$data.commonForm[type])) &&
        !add &&
        data < rules.min
    ) {
        data = rules.min;
    } else if (rules.max < data) {
        data = rules.max;
    } else if (data < rules.min) {
        data = rules.min;
    }
    if (data || 0 == data) {
        data = String(data);
        this.$set(this.$data.commonForm, type, data);
        this.$refs.commonForm.validateField(type);
    }
};
//搜索条件组装
Vue.prototype.getQueryParam = function(params) {
    let param = "";
    let queryForm = null;
    if (params) {
        queryForm = params;
    } else {
        queryForm = this.$data.queryForm;
    }

    if (queryForm) {
        for (const key in queryForm) {
            if (queryForm.hasOwnProperty(key)) {
                const element = queryForm[key];
                if (
                    null !== element &&
                    undefined !== element &&
                    0 < ("" + element).length
                ) {
                    param += "&" + key + "=" + element;
                }
            }
        }
    }
    return param;
};

//查找某个名称的vue对象
Vue.prototype.searchCompentByName = function(name) {
    if (!name || name.trim().length <= 0) {
        return null;
    }
    if (name === this.$options.name) {
        return this;
    } else if (!this.isEmptyArray(this.$children)) {
        const child = this.$children;
        for (let index = 0; index < child.length; index++) {
            const element = child[index];
            const compent = element.searchCompentByName(name);
            if (compent) {
                return compent;
            }
        }
    }
    return null;
};
Vue.prototype.defaultGutterWidth = 6; //设置默认的gutter宽度
Vue.prototype.setGutterWidth = function() {
    let gutterWidth = this.$data.gutterWidth ? this.$data.gutterWidth : this.defaultGutterWidth;
    if (gutterWidth) {
        this.$refs.commonTable.$data.layout.gutterWidth = gutterWidth; //重新设置表格gutter
    }
};

Vue.prototype.logOut = function() {
    let tips = "<i class='el-icon-warn-tip'></i>是否确定退出登录?";
    this.$confirm(tips, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            cancelButtonClass: "cancel",
        })
        .then(() => {
            window.sessionStorage.clear();
            this.$router.push({
                path: "/login",
            });
            // this.deleteRequest("/token-server/api/logout").then((res) => {
            //     let oData = res.data;
            //     if (oData.code == 0) {
            //         window.sessionStorage.clear();
            //         this.$router.push({
            //             path: "/login",
            //         });
            //     } else {
            //         let tips = "<i class='el-icon-warn-tip'></i>退出登录失败~";
            //         this.$confirm(tips, "提示", {
            //             confirmButtonText: "好的",
            //             customClass: "confirmClass-style",
            //             iconClass: "",
            //             confirmButtonClass: "confirm",
            //             dangerouslyUseHTMLString: true,
            //             showCancelButton: false,
            //         });
            //     }
            // });
        })
        .catch((err) => {

        });
};

Vue.prototype.defaultClearValidate = function(formName) {
    if (this.isEmptyStr(formName)) {
        formName = "commonForm";
    }
    this.$nextTick(function() {
        this.$refs[formName].clearValidate(); //清除校验结果
    });
};

/**
 *
 * @param {*} data = {
 *                      show:boolean //是否显示;
 *                      type:number  //空域类型 1:禁区 2:限制区 3:临时飞行区 4:净空区 5:危险区
 *                   }
 */
Vue.prototype.defaultShowAirspace = function(olMap, data) {
    airspaceObj.showAirspace(olMap, data, this);
}



// WEBPACK FOOTER //
// ./src/main.js